import AlertCircle from "@untitled-ui/icons-react/build/esm/AlertCircle";
import BankNote01 from "@untitled-ui/icons-react/build/esm/BankNote01";
import CheckCircle from "@untitled-ui/icons-react/build/esm/CheckCircle";
import InfoCircle from "@untitled-ui/icons-react/build/esm/InfoCircle";
import List from "@untitled-ui/icons-react/build/esm/List";
import Palette from "@untitled-ui/icons-react/build/esm/Palette";
import Ruler from "@untitled-ui/icons-react/build/esm/Ruler";
import Snowflake02 from "@untitled-ui/icons-react/build/esm/Snowflake02";
import Tag03 from "@untitled-ui/icons-react/build/esm/Tag03";
import Type01 from "@untitled-ui/icons-react/build/esm/Type01";
import Users03 from "@untitled-ui/icons-react/build/esm/Users03";
import { useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import PopupContext from "../../../../PopupContext";
import * as Library from "../../../../utils/Library";
import BtnLargeSolid from "../../../common/buttons/BtnLargeSolid";
import CheckboxVector from "../../../common/checkbox/CheckboxVector";
import { AlertIcon } from "../../../common/dialogs/DialogBoxComponent";
import FormContainer from "../../../common/forms/FormContainer";
import FormField from "../../../common/forms/FormField";
import RadioButtonVector from "../../../common/radioButton/RadioButtonVector";
import Tooltip from "../../../common/tooltip/TooltipSimple";

// #region SCOPED CSS
const FormStyles = styled.div`
    .title-section {
        padding: 0 0px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        margin-bottom: 8px;
    }

    .main-title {
        color: #fff;
        font-size: 20px;
        padding: 0 8px;
    }

    .sub-title {
        color: var(--text-icons-gray-100);
        font-size: 14px;
        padding: 0 8px;
    }

    .content-sections {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }

    .section-card {
        background: var(--backgrounds-lines-n-300);
        border-radius: 5px;
        padding: 12px 16px 16px 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .brand-name-card {
        transition: border-color 0.5s ease-in-out;
        border: 1px solid transparent;
    }

    .brand-name-card.highlighted-red {
        border: 1px solid var(--text-icons-red-500);
    }

    .brand-name-card.highlighted-green {
        border: 1px solid var(--text-icons-green-500);
    }

    .section-header {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .section-header-icon {
        color: var(--text-icons-green-500);
        font-size: 14px;
        width: 16px;
        flex-shrink: 0;
    }

    .section-header-title {
        color: var(--text-icons-green-500);
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .section-header-icon.shrink-0 {
        display: flex;
        flex-shrink: 0;
    }

    .mapping-status-icon {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }

    .form-row {
        padding: 6px 0px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .form-row-fill,
    .form-field-fill {
        flex: 1;
        min-width: 0;
    }

    .form-space-between {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
    }

    .price-rules-row {
        display: grid;
        grid-template-columns: auto max-content minmax(0, 1fr) auto 4px auto max-content minmax(0, 1fr) auto;
        align-items: center;
        column-gap: 10px;
        padding: 6px 0;
    }

    .price-rule-group,
    .price-rule-content {
        display: contents;
    }

    .price-rule-field {
        min-width: 0;
    }

    .text-label {
        color: var(--text-icons-gray-100);
        font-size: 14px;
        white-space: nowrap;
    }

    .text-label.muted {
        color: var(--text-icons-gray-300);
    }

    .text-subtext {
        color: var(--text-icons-gray-200);
        font-size: 11px;
    }

    .text-subtext.muted {
        color: var(--text-icons-gray-300);
    }

    .radio-group {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .radio-item {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
    }

    .add-btn {
        color: var(--text-icons-gray-100);
        background: var(--backgrounds-lines-n-600);
        padding: 5px 1px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 29px;
        height: 27px;
    }

    .add-btn.disabled {
        color: var(--text-icons-gray-300) !important;
        cursor: not-allowed;
    }

    .add-btn:hover:not(.disabled) {
        box-shadow: 0 0 0 1px var(--text-icons-orange-500);
    }

    .table-btn {
        color: var(--text-icons-gray-100);
        background: var(--backgrounds-lines-n-600);
        padding: 0 6px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 16px;
        max-width: 29px;
        cursor: pointer;
    }

    .table-btn.disabled {
        color: var(--text-icons-gray-300);
        cursor: not-allowed;
    }

    .rounding-dropdown .dropdown-text {
        color: var(--text-icons-gray-100, #d1d1d1);
        flex-grow: 0.7 !important;
    }

    /* Mapping cards row: Seasons, Genders, Categories, Sizes, Colors */
    .mapping-cards-row {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        align-self: stretch;
    }

    .mapping-cards-row .section-card {
        flex: 1;
        padding: 16px;
        gap: 14px;
        width: 138px;
    }

    .section-action-btn {
        background: var(--backgrounds-lines-n-600);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        height: 35px;
        color: var(--text-icons-gray-100);
        font-size: 12px;
        letter-spacing: 0.0125em;
        text-transform: uppercase;
        cursor: pointer;
    }

    .section-action-btn:hover {
        box-shadow: 0 0 0 1px var(--text-icons-orange-500);
    }

    .brand-match-dropdown .dropdown-item:first-child {
        border-bottom: 1px solid #1a222d;
    }

    .brand-match-dropdown.highlight {
        //border: 1px solid var(--text-icons-orange-500);
        box-shadow: 0 0 0 1px var(--text-icons-orange-500);
        border-radius: 4px;
    }

    .RRP-tooltip {
        color: #ffffff;
        text-align: left;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .RRP-span {
        font-weight: 600;
    }

    .icon-enabled {
        color: var(--text-icons-gray-100);
    }

    .icon-disabled {
        color: var(--text-icons-gray-200);
    }

    .icon-enabled-check {
        ${props => (props.formsEnabled ? "color: var(--text-icons-gray-100);" : "color: var(--text-icons-gray-200);")}
    }

    //MUTED Section
    .section-card.muted .section-header span {
        color: var(--text-icons-gray-300) !important;
    }

    .section-card.muted .section-header svg {
        color: var(--text-icons-gray-300) !important;
    }
`;
// #endregion

// #region CONFIG VALUES
const MAX_COST_DISCOUNT_PERCENTAGE = 99.99;

export const ROUNDING_PRICE_OPTIONS = [
    {
        value: "previous-1",
        nameWithoutDescription: "Apply -1 to rounded",
        name: "Apply -1 to rounded (2.000,00 → 1.999,00)",
        description: "(2.000,00 → 1.999,00)"
    },
    {
        value: "previous-5",
        nameWithoutDescription: "Round down to prev 5",
        name: "Round down to prev 5 (1.999,00 → 1.995,00)",
        description: "(1.999,00 → 1.995,00)"
    },
    {
        value: "previous-50",
        nameWithoutDescription: "Round down to prev 50",
        name: "Round down to prev 50 (1.999,00 → 1.950,00)",
        description: "(1.999,00 → 1.950,00)"
    },
    {
        value: "next0,50",
        nameWithoutDescription: "Round up to next 0,50",
        name: "Round up to next 0,50 (5,21 → 5,50 | 5,50 → 5,50 | 5,51 → 6,00)",
        description: "(5,21 → 5,50 | 5,50 → 5,50 | 5,51 → 6,00)"
    },
    {
        value: "next5",
        nameWithoutDescription: "Round up to next 5",
        name: "Round up to next 5 (1.499,00 → 1.500,00 | 1.501,00 → 1.505,00)",
        description: "(1.499,00 → 1.500,00 | 1.501,00 → 1.505,00)"
    },
    {
        value: "next10",
        nameWithoutDescription: "Round up to next 10",
        name: "Round up to next 10 (1.491,00 → 1.500,00)",
        description: "(1.491,00 → 1.500,00)"
    },
    {
        value: "next50",
        nameWithoutDescription: "Round up to next 50",
        name: "Round up to next 50 (1.450,00 → 1.450,00 | 1.451,00 → 1.500,00)",
        description: "(1.450,00 → 1.450,00 | 1.451,00 → 1.500,00)"
    },
    {
        value: "next100",
        nameWithoutDescription: "Round up to next 100",
        name: "Round up to next 100 (1.401,00 → 1.500,00)",
        description: "(1.401,00 → 1.500,00)"
    }
];

export const LANGUAGES_OPTIONS = [
    { value: "da", name: "Danish", locked: true },
    { value: "en", name: "English", locked: true },
    { value: "no", name: "Norwegian", locked: false },
    { value: "sv", name: "Swedish", locked: true }
];
// #endregion

export default function POSExpRulesCard({
    brandName = "--",
    brandExportRules = {},
    setBrandExportRules,
    allPOSBrands,
    setAllPOSBrands,
    posHasMatch = undefined,
    formsEnabled = false,
    setFormsEnabled,
    setSaveButtonEnabled,
    mappingCompletion = {},
    hasLabelBrandProducts = true,
    onManualBrandMatch,
    setShowSeasonsTablePopup,
    setShowGendersTablePopup,
    setShowCategoriesTablePopup,
    setShowColorsTablePopup,
    onShowSizesClicked,
    sizesPopupEnabled,
    showRulesSaved,
    setPosHasMatch,
    resetDataStates
}) {
    // #region STATES
    const { setGenericConfirmationPopup } = useContext(PopupContext);
    const [temporaryHighlightBrand, setTemporaryHighlightBrand] = useState(false);
    const dropdownOutsideRef = useRef(null);

    // #endregion

    // #region METHODS
    const onBrandExportRuleChange = (key, data) => {
        setBrandExportRules(prev => ({ ...prev, [key]: data }));
    };

    const onDropdownChange = (data, stateData, setter) => {
        const updated = stateData.map(item => ({ ...item, selected: item.value === data.value }));
        setter(updated);
    };

    const onPOSBrandChange = data => {
        onDropdownChange(data, allPOSBrands, setAllPOSBrands);

        if (data?.value) {
            //if is create new
            if (data?.value === "create-new") {
                setFormsEnabled?.(false);
                resetDataStates();
                setSaveButtonEnabled?.(false);

                Library.showConfirmationMessage({
                    setGenericConfirmationPopup,
                    useV2: true,
                    useIconSrc: AlertIcon(),
                    title: "Creating new brand in your POS",
                    message: `Please confirm you’d like BOtag to create a new brand in your POS system called ${brandName}.`,
                    confirmText: "CONFIRM",
                    cancelText: "CANCEL",
                    confirmState: "secondary",
                    cancelState: "secondary",
                    confirmTextColor: "var(--text-icons-orange-500)",
                    headingColor: "var(--text-icons-orange-500)",
                    headingText: "ATTENTION!!",
                    onConfirmClicked: () => {
                        setFormsEnabled?.(true);
                        setSaveButtonEnabled?.(true);
                        onManualBrandMatch?.();
                        setPosHasMatch(true);

                        //select and rename "create-new" to the brand name:
                        const temp = allPOSBrands.map(item => ({
                            ...item,
                            selected: item.value === "create-new",
                            name: item.value === "create-new" ? `Create new: ${brandName}` : item.name
                        }));
                        setAllPOSBrands(temp);
                    },
                    onCancelClicked: () => {
                        setFormsEnabled?.(false);
                        setSaveButtonEnabled?.(false);
                        setPosHasMatch(false);
                        setAllPOSBrands(prev => prev.map(item => ({ ...item, selected: false })));
                    }
                });
                return;
            }
            setFormsEnabled?.(true);
            setSaveButtonEnabled?.(true);
            onManualBrandMatch?.();
            setPosHasMatch(true);
        }
    };

    // Mapping status indicators: CheckCircle (done) vs AlertCircle (pending)
    const isSeasonMappingsComplete = !!mappingCompletion.seasons;
    const isGenderMappingsComplete = !!mappingCompletion.genders;
    const isCategoryMappingsComplete = !!mappingCompletion.categories;
    const isSizeMappingsComplete = !!mappingCompletion.sizes;
    const isColorMappingsComplete = !!mappingCompletion.colors;

    const colorNameSource = brandExportRules.productNameColorSource === "POS" ? "POS" : "Brand";
    const colorNameSourceEnabled = formsEnabled && !!brandExportRules.addColorName;
    const mappingButtonsEnabled = formsEnabled && hasLabelBrandProducts;
    // #endregion

    // #region USE EFFECTS
    useEffect(() => {
        if (posHasMatch === undefined) return;

        // Green highlight for match, red for no match
        setTemporaryHighlightBrand(posHasMatch ? "green" : "");

        if (posHasMatch) {
            const handleClick = () => {
                setTemporaryHighlightBrand(false);
                document.removeEventListener("click", handleClick);
            };
            document.addEventListener("click", handleClick);

            return () => document.removeEventListener("click", handleClick);
        }
    }, [posHasMatch]); // If match found, highlight green until user clicks anywhere. If no match, highlight red.

    useEffect(() => {
        if (!posHasMatch && formsEnabled) setTemporaryHighlightBrand(false);
    }, [formsEnabled, posHasMatch]); // If no match and user manually enables forms (selects a POS brand), remove highlight
    // #endregion

    // #region RENDER
    return (
        <FormContainer
            className="w-100"
            title={showRulesSaved && formsEnabled ? brandName + " - Rules saved" : brandName}>
            <FormStyles formsEnabled={formsEnabled} className={`${!formsEnabled && "form-muted"} w-100`}>
                <div className="title-section" onClick={() => setSaveButtonEnabled(false)}>
                    <div className="main-title">Set rules to export products for - {brandName}</div>
                    <div className="sub-title">
                        Define how you'd like {brandName} products to be exported to your POS
                    </div>
                </div>

                <div className="content-sections">
                    {/* BRAND NAME Section */}
                    <div
                        className={`section-card brand-name-card ${temporaryHighlightBrand ? `highlighted-${temporaryHighlightBrand}` : ""}`}>
                        <div className="section-header">
                            <Tag03 height="16px" className="section-header-icon" />
                            <span className="section-header-title">BRAND NAME</span>
                        </div>
                        <div className="form-row">
                            <span className="text-label" style={{ marginRight: "3px" }}>
                                This brand is identified in your POS system as:
                            </span>
                            <div style={{ flex: 1 }}>
                                <FormField
                                    className={`brand-match-dropdown ${posHasMatch === false ? "highlight" : ""}`}
                                    type="dropdown"
                                    dropdownData={allPOSBrands}
                                    varName="brandDropdown"
                                    isDropdownSearchable={true}
                                    isDropdownMultiselect={false}
                                    placeholder="Select this brand from your POS"
                                    onDropdownChange={onPOSBrandChange}
                                    formFieldColumSize={1}
                                    styling={{
                                        formFieldWidth: "100%",
                                        formFieldHeight: "27px",
                                        dropdownOverlayTop: "35px"
                                    }}
                                    style={{ justifySelf: "flex-end" }}
                                    disableTooltip={true}
                                    disableAssistiveText={true}
                                />
                            </div>
                            <Tooltip
                                width="350px"
                                header="This connects the BOtag Label Brand to the brand name used in Front Systems."
                                title={
                                    <>
                                        Select the exact Front Systems brand if it already exists. BOtag may suggest
                                        similar matches, for example when spacing or spelling differs.
                                        <br />
                                        You can use the suggested match, choose another Front Systems brand, or create a
                                        new one.
                                        <br />
                                        <br />
                                        Choosing “Create new” means BOtag will add this brand to Front Systems when the
                                        export rules are saved/applied.
                                        <br />
                                        <br />
                                        This does not rename the Label Brand in BOtag; it only controls the Front
                                        Systems export.
                                    </>
                                }>
                                <InfoCircle
                                    className="icon-enabled-check"
                                    height="16px"
                                />
                            </Tooltip>
                        </div>
                    </div>

                    {/* TEXT Section */}
                    <div className={`section-card ${!formsEnabled ? "muted" : ""}`}>
                        <div className="section-header">
                            <Type01 height="16px" className="section-header-icon" />
                            <span className="section-header-title">TEXT</span>
                        </div>

                        <div className="form-space-between">
                            <div className="form-row">
                                <CheckboxVector
                                    disabled={true}
                                    isChecked={true}
                                    useGreenColorVariant={true}
                                    onCheckboxClick={() =>
                                        setBrandExportRules(prev => ({
                                            ...prev,
                                            showProductName: !prev.showProductName
                                        }))
                                    }
                                />
                                <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>
                                    Export the product name with format:
                                </span>
                                <div className="radio-group" style={{ flex: 1, marginLeft: "3px" }}>
                                    <div className="radio-item">
                                        <RadioButtonVector
                                            onClick={() => {
                                                setBrandExportRules(prev => ({ ...prev, format: "Uppercase" }));
                                                setSaveButtonEnabled(true);
                                            }}
                                            disabled={!formsEnabled}
                                            isSelected={brandExportRules.format === "Uppercase"}
                                            radioColor="var(--Buttons-Green-Outline)"
                                        />
                                        <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>AG</span>
                                    </div>
                                    <div className="radio-item">
                                        <RadioButtonVector
                                            onClick={() => {
                                                setBrandExportRules(prev => ({ ...prev, format: "Capitalized" }));
                                                setSaveButtonEnabled(true);
                                            }}
                                            disabled={!formsEnabled}
                                            isSelected={brandExportRules.format === "Capitalized"}
                                            radioColor="var(--Buttons-Green-Outline)"
                                        />
                                        <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>Ag</span>
                                    </div>
                                </div>
                                <Tooltip
                                    width="300px"
                                    header="Choose how the product name should appear in Front Systems."
                                    title={
                                        <>
                                            “AG” shows the exported product name in uppercase letters.
                                            <br />
                                            “Ag” shows the exported product name with standard capitalization.
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>

                            <div className="form-row">
                                <CheckboxVector
                                    disabled={!formsEnabled}
                                    useGreenColorVariant={true}
                                    isChecked={brandExportRules.addProductNameSuffix}
                                    onCheckboxClick={() => {
                                        const willEnable = !brandExportRules.addProductNameSuffix;
                                        setBrandExportRules(prev => ({
                                            ...prev,
                                            addProductNameSuffix: willEnable,
                                            productNameSuffix: willEnable ? prev.productNameSuffix : ""
                                        }));

                                        setSaveButtonEnabled(true);
                                    }}
                                />
                                <span
                                    className={`text-label ${!formsEnabled ? "muted" : ""}`}
                                    style={{ flex: 1, width: "160px", marginRight: "3px" }}>
                                    Add text to product name:
                                </span>

                                <FormField
                                    type="text"
                                    varName="productNameSuffix"
                                    placeholder="Add text"
                                    maxLength={6}
                                    onTextChange={val => {
                                        onBrandExportRuleChange("productNameSuffix", val);
                                        setSaveButtonEnabled(true);
                                    }}
                                    formFieldColumSize={1}
                                    styling={{
                                        formFieldHeight: "27px",
                                        formFieldWidth: "92px"
                                    }}
                                    style={{ justifySelf: "flex-end" }}
                                    requiredType={
                                        formsEnabled && brandExportRules.addProductNameSuffix ? "simple" : "locked"
                                    }
                                    value={brandExportRules.productNameSuffix}
                                    disableTooltip={true}
                                    disableAssistiveText={true}
                                />
                                <Tooltip
                                    width="350px"
                                    header="Add up to 6 characters to the end of the product name exported to Front Systems."
                                    title={
                                        <>
                                            The text is added exactly as typed. BOtag does not add spaces automatically,
                                            so type a space if you want one. The preview updates immediately. This does
                                            not change the original product name in BOtag.
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>
                        </div>

                        <div className="form-space-between">
                            <div className="form-row form-row-fill">
                                <CheckboxVector
                                    disabled={!formsEnabled}
                                    useGreenColorVariant={true}
                                    isChecked={brandExportRules.translateDesc}
                                    onCheckboxClick={() => {
                                        const isClicked = !brandExportRules.translateDesc;
                                        setBrandExportRules(prev => ({ ...prev, translateDesc: !prev.translateDesc }));

                                        if (!isClicked) {
                                            setBrandExportRules(prev => ({ ...prev, translateDescLanguage: "" }));
                                            setBrandExportRules(prev => ({ ...prev, translateDescLangCode: "" }));
                                        }

                                        setSaveButtonEnabled(true);
                                        dropdownOutsideRef.current.click();
                                    }}
                                />
                                <span
                                    className={`text-label ${!formsEnabled ? "muted" : ""}`}
                                    style={{ marginRight: "3px" }}>
                                    Translate all selected product info from 'INFO AVAILABLE' to this language:
                                </span>
                                <div className="form-field-fill">
                                    <FormField
                                        type="dropdown"
                                        dropdownData={LANGUAGES_OPTIONS}
                                        varName="languagesDropdown"
                                        isDropdownSearchable={true}
                                        isDropdownMultiselect={false}
                                        placeholder="Select language"
                                        onDropdownChange={data => {
                                            if (data?.locked) return;

                                            onBrandExportRuleChange("translateDescLanguage", data.name);
                                            onBrandExportRuleChange("translateDescLangCode", data.value);
                                            setSaveButtonEnabled(true);
                                        }}
                                        formFieldColumSize={1}
                                        styling={{
                                            formFieldHeight: "27px",
                                            formFieldWidth: "100%",
                                            dropdownOverlayTop: "35px"
                                        }}
                                        style={{ justifySelf: "flex-end" }}
                                        requiredType={
                                            formsEnabled && brandExportRules.translateDesc ? "simple" : "locked"
                                        }
                                        value={brandExportRules.translateDescLanguage}
                                        disableTooltip={true}
                                        disableAssistiveText={true}
                                        dropdownSettings={{
                                            hasLockedFields: true
                                        }}
                                    />
                                </div>
                                <Tooltip
                                    width="350px"
                                    header="Choose the language used for product text exported to Front Systems."
                                    title={
                                        <>
                                            BOtag uses nanaBO AI to translate the product description and other selected
                                            product master fields into this language. Any product information added from
                                            the “Info Available” section into the Front Systems text box will also be
                                            translated.
                                            <br />
                                            The preview on the right updates so you can see how the translated text will
                                            appear before saving.
                                            <br />
                                            <br />
                                            AI translations may need review for brand-specific words, technical terms,
                                            materials, or product names.
                                            <br />
                                            <br />
                                            This does not change the original product data in BOtag. It only controls
                                            the text exported to Front Systems.
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    {/* COLORS Section */}
                    <div className={`section-card ${!formsEnabled ? "muted" : ""}`}>
                        <div className="section-header">
                            <Palette height="16px" className="section-header-icon" />
                            <span className="section-header-title">COLORS</span>
                        </div>

                        <div className="form-space-between">
                            <div className="form-row">
                                <CheckboxVector
                                    disabled={!formsEnabled}
                                    useGreenColorVariant={true}
                                    isChecked={!!brandExportRules.useBrandColorNameInColorCode}
                                    onCheckboxClick={() => {
                                        setBrandExportRules(prev => ({
                                            ...prev,
                                            useBrandColorNameInColorCode: !prev.useBrandColorNameInColorCode
                                        }));
                                        setSaveButtonEnabled(true);
                                    }}
                                />
                                <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>
                                    Show Brand Color in POS Color Code field
                                </span>
                                <Tooltip
                                    width="300px"
                                    header="Brand Color Name in POS Color Code field"
                                    title={
                                        <>
                                            Use this when you want the Brand’s original color name to be exported into
                                            the Front Systems Color Code field.
                                            <br />
                                            <br />
                                            When enabled, BOtag sends the brand color name to the POS Color Code field.
                                            The Brand Color Code will not be exported.
                                            <br />
                                            <br />
                                            This does not change the original BOtag color data. It only controls how
                                            color information is exported to Front Systems."
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>

                            <div className="form-row">
                                <CheckboxVector
                                    disabled={!formsEnabled}
                                    useGreenColorVariant={true}
                                    isChecked={brandExportRules.addColorName}
                                    onCheckboxClick={() => {
                                        setBrandExportRules(prev => {
                                            const willEnable = !prev.addColorName;

                                            return {
                                                ...prev,
                                                addColorName: willEnable,
                                                productNameColorSource: willEnable
                                                    ? prev.productNameColorSource || "Brand"
                                                    : "Brand"
                                            };
                                        });
                                        setSaveButtonEnabled(true);
                                    }}
                                />
                                <span
                                    className={`text-label ${!formsEnabled ? "muted" : ""}`}
                                    style={{ marginRight: "3px" }}>
                                    Add Color name after product name
                                </span>

                                <div className="radio-group" style={{ marginLeft: "3px" }}>
                                    <div className="radio-item">
                                        <RadioButtonVector
                                            disabled={!colorNameSourceEnabled}
                                            isSelected={brandExportRules.addColorName && colorNameSource === "POS"}
                                            onClick={() => {
                                                setBrandExportRules(prev => ({
                                                    ...prev,
                                                    productNameColorSource: "POS"
                                                }));
                                                setSaveButtonEnabled(true);
                                            }}
                                            radioColor="var(--Buttons-Green-Outline)"
                                        />
                                        <span className={`text-label ${!colorNameSourceEnabled ? "muted" : ""}`}>
                                            POS
                                        </span>
                                    </div>

                                    <div className="radio-item">
                                        <RadioButtonVector
                                            disabled={!colorNameSourceEnabled}
                                            isSelected={!brandExportRules.addColorName || colorNameSource === "Brand"}
                                            onClick={() => {
                                                setBrandExportRules(prev => ({
                                                    ...prev,
                                                    productNameColorSource: "Brand"
                                                }));
                                                setSaveButtonEnabled(true);
                                            }}
                                            radioColor="var(--Buttons-Green-Outline)"
                                        />
                                        <span className={`text-label ${!colorNameSourceEnabled ? "muted" : ""}`}>
                                            Brand
                                        </span>
                                    </div>
                                </div>

                                <Tooltip
                                    width="350px"
                                    header="Brand Color Name in POS Color Code field"
                                    title={
                                        <>
                                            Use this when you want the Brand’s original color name to be exported into
                                            the Front Systems Color Code field. <br />
                                            <br />
                                            When enabled, BOtag sends the brand color name to the POS Color Code field.
                                            The Brand Color Code will not be exported. <br />
                                            <br />
                                            This does not change the original BOtag color data. It only controls how
                                            color information is exported to Front Systems."
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    {/* PRICES Section */}
                    <div className={`section-card ${!formsEnabled ? "muted" : ""}`}>
                        <div className="section-header">
                            <BankNote01 height="16px" className="section-header-icon" />
                            <span className="section-header-title">PRICES</span>
                        </div>

                        <div className="price-rules-row">
                            <div className="price-rule-group">
                                <div className="price-rule-content">
                                    <CheckboxVector
                                        disabled={!formsEnabled}
                                        useGreenColorVariant={true}
                                        isChecked={brandExportRules.applyDiscount}
                                        onCheckboxClick={() => {
                                            const willEnable = !brandExportRules.applyDiscount;
                                            setBrandExportRules(prev => ({
                                                ...prev,
                                                applyDiscount: willEnable,
                                                costDiscountPercentage: willEnable ? prev.costDiscountPercentage : ""
                                            }));

                                            setSaveButtonEnabled(true);
                                        }}
                                    />
                                    <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>
                                        Apply this (%) discount to cost price:
                                    </span>
                                    <div className="price-rule-field">
                                        <FormField
                                            type="text"
                                            varName="costDiscountPercentage"
                                            placeholder="insert..."
                                            onKeyDown={e => {
                                                const currentVal = brandExportRules.costDiscountPercentage || "";
                                                const numericPart = currentVal.replace("%", "");

                                                // Allow: Backspace, Delete, Tab, Escape, Arrow keys, Home, End
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "Tab",
                                                    "Escape",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Home",
                                                    "End"
                                                ];
                                                if (allowedKeys.includes(e.key)) return;

                                                // Validate next value string if a digit is pressed
                                                if (/^[0-9]$/.test(e.key)) {
                                                    const start = e.target.selectionStart || 0;
                                                    const end = e.target.selectionEnd || 0;
                                                    const nextRawValue =
                                                        e.target.value.substring(0, start) +
                                                        e.key +
                                                        e.target.value.substring(end);
                                                    const nextNumericPart = nextRawValue.replace("%", "");

                                                    // 1. Check max value
                                                    if (
                                                        Number(nextNumericPart.replace(",", ".")) >
                                                        MAX_COST_DISCOUNT_PERCENTAGE
                                                    ) {
                                                        e.preventDefault();
                                                        return;
                                                    }

                                                    // 2. Check decimal limit
                                                    const commaIdx = nextNumericPart.indexOf(",");
                                                    if (commaIdx !== -1) {
                                                        const decimals = nextNumericPart.slice(commaIdx + 1);
                                                        if (decimals.length > 2) {
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                    }

                                                    return; // permit the digit
                                                }

                                                // Allow comma or period (as decimal separator) only if there isn't one already
                                                if (e.key === "," || e.key === ".") {
                                                    if (numericPart.includes(",")) {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                    return; // allow comma/period
                                                }

                                                // Block everything else
                                                e.preventDefault();
                                                setSaveButtonEnabled(true);
                                            }}
                                            onTextChange={val => {
                                                const oldVal = brandExportRules.costDiscountPercentage || "";

                                                // Handle dot→comma, strip non-numeric/comma chars
                                                let cleaned = val.replace(/\./g, ",").replace(/[^0-9,]/g, "");

                                                // Simulate proper backspace if the user just deleted the "%" char
                                                if (val === oldVal.slice(0, -1) && oldVal.endsWith("%")) {
                                                    cleaned = cleaned.slice(0, -1);
                                                }

                                                // Remove trailing comma if it's the only thing left after backspace
                                                if (cleaned.endsWith(",") && cleaned.length === 1) {
                                                    cleaned = "";
                                                }

                                                // Fallback for pasted or external values exceeding MAX
                                                if (Number(cleaned.replace(",", ".")) > MAX_COST_DISCOUNT_PERCENTAGE) {
                                                    cleaned = oldVal.replace("%", "");
                                                }

                                                if (cleaned) {
                                                    cleaned += "%";
                                                }
                                                onBrandExportRuleChange("costDiscountPercentage", cleaned);
                                                setSaveButtonEnabled(true);
                                            }}
                                            formFieldColumSize={1}
                                            styling={{
                                                formFieldHeight: "27px",
                                                formFieldWidth: "100%"
                                            }}
                                            style={{ justifySelf: "flex-end" }}
                                            requiredType={
                                                formsEnabled && brandExportRules.applyDiscount ? "simple" : "locked"
                                            }
                                            value={brandExportRules.costDiscountPercentage}
                                            disableTooltip={true}
                                            disableAssistiveText={true}
                                        />
                                    </div>
                                    <Tooltip
                                        width="350px"
                                        header="Apply a percentage discount to the cost price exported to Front Systems."
                                        title={
                                            <>
                                                Apply a percentage discount to the cost price exported to Front Systems.
                                                <br />
                                                <br />
                                                BOtag reduces the cost price by the percentage entered here and updates
                                                the preview immediately.
                                                <br />
                                                <br />
                                                This does not change the original cost price in BOtag; it only affects
                                                the value sent to Front Systems.
                                            </>
                                        }>
                                        <InfoCircle
                                            className="icon-enabled-check"
                                            height="16px"
                                        />
                                    </Tooltip>
                                </div>
                            </div>

                            <div className="price-rule-divider" aria-hidden="true" />

                            <div className="price-rule-group">
                                <div className="price-rule-content">
                                    <CheckboxVector
                                        disabled={!formsEnabled}
                                        useGreenColorVariant={true}
                                        isChecked={brandExportRules.applyCostTariff}
                                        onCheckboxClick={() => {
                                            const willEnable = !brandExportRules.applyCostTariff;
                                            setBrandExportRules(prev => ({
                                                ...prev,
                                                applyCostTariff: willEnable,
                                                costTariffPercentage: willEnable ? prev.costTariffPercentage : ""
                                            }));

                                            setSaveButtonEnabled(true);
                                        }}
                                    />
                                    <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>
                                        Apply custom tariff to cost:
                                    </span>
                                    <div className="price-rule-field">
                                        <FormField
                                            type="text"
                                            varName="costTariffPercentage"
                                            placeholder="insert %"
                                            onKeyDown={e => {
                                                const currentVal = brandExportRules.costTariffPercentage || "";
                                                const numericPart = currentVal.replace("%", "");

                                                // Allow: Backspace, Delete, Tab, Escape, Arrow keys, Home, End
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "Tab",
                                                    "Escape",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Home",
                                                    "End"
                                                ];
                                                if (allowedKeys.includes(e.key)) return;

                                                // Validate next value string if a digit is pressed
                                                if (/^[0-9]$/.test(e.key)) {
                                                    const start = e.target.selectionStart || 0;
                                                    const end = e.target.selectionEnd || 0;
                                                    const nextRawValue =
                                                        e.target.value.substring(0, start) +
                                                        e.key +
                                                        e.target.value.substring(end);
                                                    const nextNumericPart = nextRawValue.replace("%", "");

                                                    // 1. Check max value
                                                    if (
                                                        Number(nextNumericPart.replace(",", ".")) >
                                                        MAX_COST_DISCOUNT_PERCENTAGE
                                                    ) {
                                                        e.preventDefault();
                                                        return;
                                                    }

                                                    // 2. Check decimal limit
                                                    const commaIdx = nextNumericPart.indexOf(",");
                                                    if (commaIdx !== -1) {
                                                        const decimals = nextNumericPart.slice(commaIdx + 1);
                                                        if (decimals.length > 2) {
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                    }

                                                    return; // permit the digit
                                                }

                                                // Allow comma or period (as decimal separator) only if there isn't one already
                                                if (e.key === "," || e.key === ".") {
                                                    if (numericPart.includes(",")) {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                    return; // allow comma/period
                                                }

                                                // Block everything else
                                                e.preventDefault();
                                                setSaveButtonEnabled(true);
                                            }}
                                            onTextChange={val => {
                                                const oldVal = brandExportRules.costTariffPercentage || "";

                                                // Handle dot→comma, strip non-numeric/comma chars
                                                let cleaned = val.replace(/\./g, ",").replace(/[^0-9,]/g, "");

                                                // Simulate proper backspace if the user just deleted the "%" char
                                                if (val === oldVal.slice(0, -1) && oldVal.endsWith("%")) {
                                                    cleaned = cleaned.slice(0, -1);
                                                }

                                                // Remove trailing comma if it's the only thing left after backspace
                                                if (cleaned.endsWith(",") && cleaned.length === 1) {
                                                    cleaned = "";
                                                }

                                                // Fallback for pasted or external values exceeding MAX
                                                if (Number(cleaned.replace(",", ".")) > MAX_COST_DISCOUNT_PERCENTAGE) {
                                                    cleaned = oldVal.replace("%", "");
                                                }

                                                if (cleaned) {
                                                    cleaned += "%";
                                                }
                                                onBrandExportRuleChange("costTariffPercentage", cleaned);
                                                setSaveButtonEnabled(true);
                                            }}
                                            formFieldColumSize={1}
                                            styling={{
                                                formFieldHeight: "27px",
                                                formFieldWidth: "100%"
                                            }}
                                            style={{ justifySelf: "flex-end" }}
                                            requiredType={
                                                formsEnabled && brandExportRules.applyCostTariff ? "simple" : "locked"
                                            }
                                            value={brandExportRules.costTariffPercentage}
                                            disableTooltip={true}
                                            disableAssistiveText={true}
                                        />
                                    </div>
                                    <Tooltip
                                        width="400px"
                                        header="Custom tariffs"
                                        title={
                                            <>
                                                Add a customs tariff percentage to the cost price exported to Front
                                                Systems.
                                                <br />
                                                This tariff is applied after any cost discount has already been
                                                deducted.
                                                <br />
                                                <br />
                                                Example:
                                                <br />
                                                Original cost price → discount applied → customs tariff added
                                                <br />
                                                <br />
                                                Use this field when you want BOtag to calculate the cost price with an
                                                average customs tariff for this Label Brand.
                                                <br />
                                                <br />
                                                If the product master includes item-specific customs tariff codes or
                                                tariff values, those item-specific values will be used instead and will
                                                override this average tariff.
                                                <br />
                                                BOtag checks the tariff data used for cost calculation on a scheduled
                                                basis.
                                                <br />
                                                <br />
                                                The preview on the right (POS panel) updates immediately so you can see
                                                the cost price before saving.
                                                <br />
                                                This only affects the cost price sent to Front Systems. It does not
                                                change the original BOtag cost price.
                                            </>
                                        }>
                                        <InfoCircle
                                            className="icon-enabled-check"
                                            height="16px"
                                        />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>

                        <div className="form-row" ref={dropdownOutsideRef} style={{ gap: "24px" }}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    flex: 1,
                                    minWidth: 0
                                }}>
                                <CheckboxVector
                                    disabled={!formsEnabled}
                                    useGreenColorVariant={true}
                                    isChecked={brandExportRules.roundPrice}
                                    onCheckboxClick={() => {
                                        const isClicked = !brandExportRules.roundPrice;
                                        setBrandExportRules(prev => ({ ...prev, roundPrice: !prev.roundPrice }));

                                        if (!isClicked) {
                                            setBrandExportRules(prev => ({ ...prev, roundingKey: "" }));
                                            setBrandExportRules(prev => ({ ...prev, roundingLabel: "" }));
                                        }

                                        setSaveButtonEnabled(true);
                                        dropdownOutsideRef.current.click();
                                    }}
                                />
                                <span className={`text-label ${!formsEnabled ? "muted" : ""}`}>
                                    Round retail price to:
                                </span>

                                <div style={{ flex: 1, marginLeft: "3px" }}>
                                    <FormField
                                        className="rounding-dropdown"
                                        type="dropdown"
                                        dropdownData={ROUNDING_PRICE_OPTIONS}
                                        varName="roundingDropdown"
                                        isDropdownSearchable={false}
                                        isDropdownMultiselect={false}
                                        placeholder="Select rounding preference"
                                        onDropdownChange={data => {
                                            onBrandExportRuleChange("roundingLabel", data?.name);
                                            onBrandExportRuleChange("roundingKey", data?.value);
                                            setSaveButtonEnabled(true);
                                        }}
                                        formFieldColumSize={1}
                                        styling={{
                                            formFieldHeight: "27px",
                                            formFieldWidth: "100%",
                                            //formFieldMaxWidth: "320px",
                                            dropdownOverlayTop: "35px"
                                        }}
                                        style={{ justifySelf: "flex-end" }}
                                        requiredType={formsEnabled && brandExportRules.roundPrice ? "simple" : "locked"}
                                        value={brandExportRules.roundingLabel}
                                        dropdownSettings={{
                                            hasDescriptionFields: true,
                                            descriptionStyle: { fontSize: "11px" },
                                            widthPercentage: "430px"
                                        }}
                                        disableTooltip={true}
                                        disableAssistiveText={true}
                                    />
                                </div>

                                <Tooltip
                                    width="350px"
                                    header="Choose how retail prices should be rounded when exported to Front Systems."
                                    title={
                                        <>
                                            BOtag adjusts the retail price according to the selected rounding rule, and
                                            the preview updates immediately.
                                            <br />
                                            <br />
                                            This only affects the retail price sent to Front Systems. It does not change
                                            the original BOtag retail price.
                                        </>
                                    }>
                                    <InfoCircle
                                        className="icon-enabled-check"
                                        height="16px"
                                    />
                                </Tooltip>
                            </div>
                        </div>
                    </div>

                    {/* SEASONS, GENDERS, COLORS, CATEGORIES, SIZES - mapping cards */}
                    <div className="mapping-cards-row">
                        <div className={`section-card ${!mappingButtonsEnabled ? "muted" : ""}`}>
                            <div className="section-header">
                                <Snowflake02 width="16px" height="16px" className="section-header-icon shrink-0" />
                                <span className="section-header-title">SEASONS</span>

                                <div className="mapping-status-icon">
                                    {isSeasonMappingsComplete ? (
                                        <CompleteMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    ) : (
                                        <NeedsAttentionMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    )}
                                </div>
                            </div>
                            <BtnLargeSolid
                                className="w-100"
                                text="CUSTOMIZE"
                                onClick={() => setShowSeasonsTablePopup(true)}
                                disabled={!mappingButtonsEnabled}
                                normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverBorderColor="var(--text-icons-green-500)"
                                disabledColor="var(--Buttons-All-Platforms-Gray-500)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase"
                                    //color: "var(--text-icons-gray-100)"
                                }}
                            />
                        </div>

                        <div className={`section-card ${!mappingButtonsEnabled ? "muted" : ""}`}>
                            <div className="section-header">
                                <Users03 height="16px" className="section-header-icon" />
                                <span className="section-header-title">GENDERS</span>

                                <div className="mapping-status-icon">
                                    {isGenderMappingsComplete ? (
                                        <CompleteMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    ) : (
                                        <NeedsAttentionMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    )}
                                </div>
                            </div>
                            <BtnLargeSolid
                                className="w-100"
                                text="CUSTOMIZE"
                                onClick={() => setShowGendersTablePopup(true)}
                                disabled={!mappingButtonsEnabled}
                                normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverBorderColor="var(--text-icons-green-500)"
                                disabledColor="var(--Buttons-All-Platforms-Gray-500)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase"
                                    //color: "var(--text-icons-gray-100)"
                                }}
                            />
                        </div>

                        <div className={`section-card ${!mappingButtonsEnabled ? "muted" : ""}`}>
                            <div className="section-header">
                                <Palette height="16px" className="section-header-icon" />
                                <span className="section-header-title">COLORS</span>

                                <div className="mapping-status-icon">
                                    {isColorMappingsComplete ? (
                                        <CompleteMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    ) : (
                                        <NeedsAttentionMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    )}
                                </div>
                            </div>
                            <BtnLargeSolid
                                className="w-100"
                                text="CUSTOMIZE"
                                normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverBorderColor="var(--text-icons-green-500)"
                                disabledColor="var(--Buttons-All-Platforms-Gray-500)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase"
                                    //color: "var(--text-icons-gray-300)"
                                }}
                                onClick={() => setShowColorsTablePopup(true)}
                                disabled={!mappingButtonsEnabled}
                            />
                        </div>

                        <div className={`section-card ${!mappingButtonsEnabled ? "muted" : ""}`}>
                            <div className="section-header">
                                <List height="16px" className="section-header-icon" />
                                <span className="section-header-title">CATEGS</span>

                                <div className="mapping-status-icon">
                                    {isCategoryMappingsComplete ? (
                                        <CompleteMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    ) : (
                                        <NeedsAttentionMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    )}
                                </div>
                            </div>
                            <BtnLargeSolid
                                className="w-100"
                                text="CUSTOMIZE"
                                onClick={() => setShowCategoriesTablePopup(true)}
                                disabled={!mappingButtonsEnabled}
                                normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                hoverBorderColor="var(--text-icons-green-500)"
                                disabledColor="var(--Buttons-All-Platforms-Gray-500)"
                                textStyle={{
                                    fontSize: "12px",
                                    textTransform: "uppercase"
                                    //color: "var(--text-icons-gray-300)"
                                }}
                            />
                        </div>

                        <div className={`section-card ${!mappingButtonsEnabled ? "muted" : ""}`}>
                            <div className="section-header">
                                <Ruler height="16px" className="section-header-icon" />
                                <span className="section-header-title">SIZES</span>

                                <div className="mapping-status-icon">
                                    {isSizeMappingsComplete ? (
                                        <CompleteMappingTooltip isInactive={!mappingButtonsEnabled} />
                                    ) : (
                                        <NeedsAttentionMappingTooltip
                                            isInactive={!mappingButtonsEnabled || !sizesPopupEnabled}
                                        />
                                    )}
                                </div>
                            </div>
                            <Tooltip
                                title={"Complete Categories customization first to unlock size mapping"}
                                disabled={!(mappingButtonsEnabled && !sizesPopupEnabled)}>
                                <>
                                    <BtnLargeSolid
                                        className="w-100"
                                        text="CUSTOMIZE"
                                        normalColor="var(--Buttons-All-Platforms-Gray-500)"
                                        hoverColor="var(--Buttons-All-Platforms-Gray-500)"
                                        hoverBorderColor="var(--text-icons-green-500)"
                                        disabledColor="var(--Buttons-All-Platforms-Gray-500)"
                                        textStyle={{
                                            fontSize: "12px",
                                            textTransform: "uppercase"
                                            //color: "var(--text-icons-gray-100)"
                                        }}
                                        //disabled={true}
                                        onClick={() => onShowSizesClicked()}
                                        disabled={!mappingButtonsEnabled || !sizesPopupEnabled}
                                    />
                                </>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </FormStyles>
        </FormContainer>
    );
    // #endregion
}

// #region SMALL COMPONENTS
function CompleteMappingTooltip({ isInactive = false }) {
    return (
        <Tooltip width="150px" header="Complete" title="All required links for this rule group are set.">
            <CheckCircle height="16px" className={isInactive ? "text-inactive" : "text-green"} />
        </Tooltip>
    );
}

function NeedsAttentionMappingTooltip({ isInactive = false }) {
    return (
        <Tooltip
            disabled={isInactive}
            width="150px"
            header="Needs attention"
            title="One or more required links are missing in this rule group. Open Customize to complete the setup.">
            <AlertCircle height="16px" className={isInactive ? "text-inactive" : "text-orange"} />
        </Tooltip>
    );
}
// #endregion
